<template>
    <div>
        <div class='logo'>
            <DynamicImageContainer class="logo" :image='logo' :use_random_test_images='false'/>
        </div>
        <div class='footer-address'>
          <p>The Retail Context Layer for AI</p>
        </div>
    </div>
</template>


<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";

export default {
    components: {DynamicImageContainer},
    data(){
        return{
            logo: 'logos/itim-aiq-logo.svg'
        }
    },
    methods:{
        goToHome(){
            this.$router.push('/');
        }
    }
}
</script>


<style lang="scss" scoped>
.logo{
    width: 160px;
}

.footer-address{
    font-size: 1rem;
}
</style>